export class RiskType {
  id: number;
  name: string;

  constructor(riskType: number, name: string) {
    this.id = riskType;
    this.name = name;
  }
}

export enum RiskTypeEnum {
  all = 0,
  strategic = 1,
  operational = 2,
  financial = 3
}
